import {BrowserRouter, Route, Routes} from 'react-router-dom';
import MainPage from './pages/main/MainPage';
import Error404Page from './pages/error/Error404Page';
import FAQPage from './pages/faq/FAQPage';
import ContactPage from './pages/contact/ContactPage';
import TermsUsePage from './pages/terms/TermsUsePage';
import TermsPrivacyPage from './pages/terms/TermsPrivacyPage';
import TermsEcommercePage from './pages/terms/TermsEcommercePage';
import ContactDeleteMemberPage from './pages/contact/ContactDeleteMemberPage';
import ScrollTop from './components/ScrollTop';

function App() {
  
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollTop/>
        <Routes>
          <Route path='/' element={<MainPage/>}/>
          <Route path='/faq' element={<FAQPage/>}/>
          <Route path='/contact' element={<ContactPage/>}/>
          <Route path='/contact/delete/member' element={<ContactDeleteMemberPage/>}/>
          <Route path='/terms/use' element={<TermsUsePage/>}/>
          <Route path='/terms/privacy' element={<TermsPrivacyPage/>}/>
          <Route path='/terms/ecommerce' element={<TermsEcommercePage/>} />
          <Route path='*' element={<Error404Page/>}/>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
